import { render, staticRenderFns } from "./FrameSwatch.vue?vue&type=template&id=95c5b478&scoped=true&"
import script from "./FrameSwatch.vue?vue&type=script&lang=js&"
export * from "./FrameSwatch.vue?vue&type=script&lang=js&"
import style0 from "./FrameSwatch.vue?vue&type=style&index=0&id=95c5b478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c5b478",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
